import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "form-group grided" }
const _hoisted_6 = { class: "form-group grided" }
const _hoisted_7 = { class: "sq-mts-container" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = { class: "images-main-wr" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["id", "value"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "form-group grided" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "title-wr" }, [
      _createElementVNode("div", { class: "title-row" }, [
        _createElementVNode("h1", { class: "title-main" }, "Create / Edit Listing")
      ])
    ], -1)),
    _createElementVNode("form", {
      class: "form-wr",
      onSubmit: $setup.saveListing
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "form-labels" }, "Headline", -1)),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input-large", { 'input--error': $setup.v$.headline.$error }]),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.headline) = $event)),
          placeholder: "Listing headline"
        }, null, 2), [
          [_vModelText, $setup.form.headline]
        ])
      ]),
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "form-labels" }, "State", -1)),
        _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
          control: _withCtx(() => [
            _createElementVNode("button", {
              class: _normalizeClass(["dropdown-button input-large", { 'input--error': $setup.v$.address.state.$error }]),
              type: "button"
            }, _toDisplayString($setup.form.address.state), 3)
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.StatesEnum, (state) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => ($setup.form.address.state = state),
                  class: _normalizeClass({ 'dropdown__item-active': $setup.form.address.state === state }),
                  key: state
                }, _toDisplayString(state), 11, _hoisted_4))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "form-labels" }, "Lot Number", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input-large", { 'input--error': $setup.v$.address.lotNumber.$error }]),
            type: "number",
            min: "1",
            placeholder: "Lot Number",
            name: "lotNumber",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.address.lotNumber) = $event))
          }, null, 2), [
            [_vModelText, $setup.form.address.lotNumber]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "form-labels" }, "Street Number", -1)),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input-large", { 'input--error': $setup.v$.address.streetNumber.$error }]),
              type: "number",
              min: "1",
              placeholder: "Street Number",
              name: "streetNumber",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.address.streetNumber) = $event))
            }, null, 2), [
              [_vModelText, $setup.form.address.streetNumber]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "form-labels" }, "Street Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input-large inline", { 'input--error': $setup.v$.address.street.$error }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.address.street) = $event)),
            placeholder: "Street Name"
          }, null, 2), [
            [_vModelText, $setup.form.address.street]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "form-labels" }, "Suburb", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input-large", { 'input--error': $setup.v$.address.suburb.$error }]),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.address.suburb) = $event)),
            placeholder: "Suburb",
            name: "suburb"
          }, null, 2), [
            [_vModelText, $setup.form.address.suburb]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "form-labels" }, "Postcode", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input-large", { 'input--error': $setup.v$.address.postcode.$error }]),
            maxlength: "4",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.address.postcode) = $event)),
            placeholder: "Postcode",
            name: "postcode"
          }, null, 2), [
            [_vModelText, $setup.form.address.postcode]
          ])
        ])
      ]),
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "form-labels" }, "Land Size", -1)),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input-large", { 'input--error': $setup.v$.area.$error }]),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.area) = $event)),
              name: "area",
              type: "number",
              min: "1",
              placeholder: "Land Size"
            }, null, 2), [
              [_vModelText, $setup.form.area]
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("span", null, "m²", -1))
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "form-labels" }, "Land Price", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input-large", { 'input--error': $setup.v$.price.$error }]),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.price) = $event)),
            type: "number",
            name: "price",
            min: "1",
            placeholder: "Land Price"
          }, null, 2), [
            [_vModelText, $setup.form.price]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "form-labels" }, "Description", -1)),
        _withDirectives(_createElementVNode("textarea", {
          class: _normalizeClass(["input-large", { 'input--error': $setup.v$.description.$error }]),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.description) = $event)),
          placeholder: "Add description",
          name: "description"
        }, null, 2), [
          [_vModelText, $setup.form.description]
        ])
      ]),
      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _cache[25] || (_cache[25] = _createElementVNode("p", null, "Listing Image(s)", -1)),
        _cache[26] || (_cache[26] = _createElementVNode("label", {
          class: "upload-image-button",
          for: "file-upload"
        }, "Upload Image", -1)),
        _createElementVNode("input", {
          id: "file-upload",
          type: "file",
          onChange: $setup.uploadImage,
          accept: "image/*",
          multiple: ""
        }, null, 32),
        ($setup.v$.selectedImage.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Main image is necessary"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.imageFiles, (image) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "image-wr",
              key: image.id
            }, [
              _createElementVNode("figure", null, [
                _createElementVNode("img", {
                  src: image.data,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.form.selectedImage = _ctx.id))
                }, null, 8, _hoisted_12),
                _createElementVNode("figcaption", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "mainImage",
                    id: image.id,
                    value: image.id,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.selectedImage) = $event))
                  }, null, 8, _hoisted_13), [
                    [_vModelRadio, $setup.form.selectedImage]
                  ]),
                  _createElementVNode("label", {
                    for: image.id
                  }, "Main Image", 8, _hoisted_14)
                ])
              ])
            ]))
          }), 128))
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "form-labels" }, "Agent", -1)),
          _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
            control: _withCtx(() => [
              _createElementVNode("button", {
                class: _normalizeClass(["dropdown-button input-large", { 'input--error': $setup.v$.agent.$error }]),
                type: "button"
              }, _toDisplayString($setup.form.agentName), 3)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.agentList, (agent) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: agent._id,
                    onClick: ($event: any) => ($setup.changeAgent(agent)),
                    class: _normalizeClass({ 'dropdown__item-active': $setup.form.agent === agent._id })
                  }, _toDisplayString(agent.firstName + " " + agent.lastName), 11, _hoisted_16))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "form-labels" }, "Status", -1)),
          _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
            control: _withCtx(() => [
              _createElementVNode("button", {
                class: _normalizeClass(["dropdown-button input-large", { 'input--error': $setup.v$.status.$error }]),
                type: "button"
              }, _toDisplayString($setup.form.status ? $setup.form.status[0].toUpperCase() + $setup.form.status.slice(1) : ""), 3)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ListingCreateStatus, (status) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: status,
                    onClick: ($event: any) => ($setup.form.status = status),
                    class: _normalizeClass({ 'dropdown__item-active': $setup.form.status === status })
                  }, _toDisplayString(status[0].toUpperCase() + status.slice(1)), 11, _hoisted_17))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        ($setup.form.status === $setup.ListingStatus.SOLD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "form-labels" }, "Sold Date", -1)),
              _createVNode($setup["DatePicker"], {
                modelValue: $setup.form.soldDetails.soldDate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form.soldDetails.soldDate) = $event)),
                name: "soldDate",
                max: $setup.maxDate
              }, null, 8, ["modelValue", "max"])
            ]))
          : _createCommentVNode("", true),
        ($setup.form.status === $setup.ListingStatus.SOLD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "form-labels" }, "Land Price", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input-large",
                name: "soldPrice",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.form.soldDetails.soldPrice) = $event)),
                type: "number",
                min: "1",
                placeholder: "$ 0"
              }, null, 512), [
                [_vModelText, $setup.form.soldDetails.soldPrice]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "form-labels" }, "Phone", -1)),
          _createVNode($setup["Cleave"], {
            class: _normalizeClass(["input input-large", { 'input--error': $setup.v$.phone.$error }]),
            modelValue: $setup.form.phone,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.form.phone) = $event)),
            options: $setup.phoneNumberOption($setup.form.phone),
            placeholder: "0412 345 678"
          }, null, 8, ["modelValue", "class", "options"])
        ])
      ]),
      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", { class: "form-group" }, [
        _cache[33] || (_cache[33] = _createElementVNode("button", {
          class: "save-button",
          type: "submit"
        }, "Publish", -1)),
        _createElementVNode("button", {
          class: "button",
          onClick: $setup.cancelListing
        }, "Cancel")
      ])
    ], 32)
  ]))
}